import React, { useEffect } from "react";
import { CustomCheckBox, CustomDropDown, CustomForm, CustomInput, CustomInputNumber, CustomTextArea } from "../../shared/Input/AllInputs";
import CustomImageInput from "../../shared/Input/CustomImageInput";
import PrimaryButton, { PrimaryButtonOutlined } from "../../shared/Button/PrimaryButton";
import ServiceContainer from "./ServiceContainer";
import { Dialog } from "primereact/dialog";
import ItemsTable from "./ItemsTable";
import { getSubServices } from "../../redux/actions/serviceAction";
import { useSelector } from "react-redux";
import ServiceTable from "./ServiceTable";
import Index from "./index";

const ServiceForm = ({ type }) => {
    const {
        dispatch,
        id,
        data,
        handleChange,
        onPreview,
        setFormType,
        addFeature,
        removeFeature,
        addBenefit,
        removeBenefit,
        visible,
        setVisible,
        item,
        addItem,
        editItem,
        handleItemChange,
        createItem,
        serviceTypes,
        onDeleteItem,
        onDeleteAdditionalService,
        resetItemForm,
        services,
        setLoading,
    } = ServiceContainer();

    const { loading, history, onDelete } = Index();

    let { subServices } = useSelector((state) => state.service);

    useEffect(() => {
        if (id) {
            dispatch(getSubServices(setLoading, id));
        }
    }, [dispatch, id, setLoading]);

    useEffect(() => {
        setFormType(type);
    }, [type, setFormType]);

    return (
        <>
            <CustomForm style={type === "VIEW" ? { pointerEvents: "none" } : {}}>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <CustomImageInput name="iconImage" label="Icon" key="iconImage" data={data} editable={true} onFilesChange={handleChange} />

                    <div className="grid col-8">
                        <CustomInput col={5} key="serviceName" label="Service Name" name="serviceName" data={data} onChange={handleChange} />
                        <CustomDropDown
                            col={7}
                            key="service"
                            label="Parent Service (Select to create a sub service)"
                            name="service"
                            placeholder="Service"
                            options={services}
                            optionLabel="serviceName"
                            optionValue="_id"
                            data={data}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="w-full">
                        <div className="grid col-8">
                            <CustomDropDown
                                key="serviceType"
                                label="Service Type"
                                name="serviceType"
                                options={serviceTypes}
                                optionLabel="name"
                                optionValue="value"
                                data={data}
                                onChange={handleChange}
                            />
                            <CustomInputNumber
                                key="price"
                                maxFractionDigits={2}
                                locale="en-US"
                                label="Price"
                                name="price"
                                data={data}
                                onChange={handleChange}
                            />
                        </div>
                        <CustomTextArea key="description" label="Description" name="description" data={data} col={8} onChange={handleChange} />
                        <CustomTextArea key="serviceDescription" label="Sub Heading" name="serviceDescription" data={data} col={8} onChange={handleChange} />
                    </div>
                </div>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <h5 className="m-0 col-11">Features</h5>
                    <i className="pi pi-plus text-green-600 cursor-pointer text-right col-1 m-0" onClick={addFeature}></i>
                    {data?.features?.map((feature, index) => {
                        return (
                            <div key={"feature " + index} className="w-full flex align-items-center">
                                <CustomInput
                                    name="description"
                                    formArrayName="features"
                                    index={index}
                                    data={feature}
                                    onChange={handleChange}
                                    col={8}
                                />
                                {index > 0 ? (
                                    <i className="pi pi-times text-red-600 cursor-pointer col-1" onClick={() => removeFeature(index)}></i>
                                ) : null}
                            </div>
                        );
                    })}
                </div>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <h5 className="m-0 mt-5 col-12">About</h5>
                    <div className="flex flex-column w-full">
                        <CustomInput col={8} key="about.title" label="Title" name="about.title" value={data?.about?.title} onChange={handleChange} />
                        <CustomTextArea
                            col={8}
                            key="about.description"
                            label="Description"
                            name="about.description"
                            value={data?.about?.description}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <CustomCheckBox
                        key="hasBeforeAfterImages"
                        label={"Has Before After Images"}
                        name="hasBeforeAfterImages"
                        data={data}
                        onChange={handleChange}
                        col={12}
                    />

                    {data?.hasBeforeAfterImages ? (
                        <>
                            <CustomImageInput
                                name="primaryBeforeImage"
                                label="Primary Before Image"
                                key="primaryBeforeImage"
                                data={data}
                                editable={true}
                                onFilesChange={handleChange}
                                col={3}
                            />
                            <CustomImageInput
                                key="primaryAfterImage"
                                name="primaryAfterImage"
                                label="Primary After Image"
                                data={data}
                                editable={true}
                                onFilesChange={handleChange}
                                col={3}
                            />
                        </>
                    ) : (
                        <>
                            <CustomImageInput
                                key="primarySingleImage"
                                name="primarySingleImage"
                                label="Primary Single Image"
                                data={data}
                                editable={true}
                                onFilesChange={handleChange}
                                col={3}
                            />
                        </>
                    )}
                    <div className="col-12">
                        <CustomInput
                            col={8}
                            key="secondaryImageTitle"
                            label="Secondary Image Title"
                            name="secondaryImageTitle"
                            data={data}
                            onChange={handleChange}
                        />
                    </div>

                    {data?.hasBeforeAfterImages ? (
                        <>
                            <CustomImageInput
                                name="secondaryBeforeImage"
                                label="Secondary Before Image"
                                data={data}
                                editable={true}
                                onFilesChange={handleChange}
                                col={3}
                            />
                            <CustomImageInput
                                name="secondaryAfterImage"
                                label="Secondary After Image"
                                data={data}
                                editable={true}
                                onFilesChange={handleChange}
                                col={3}
                            />
                        </>
                    ) : (
                        <div className="col-12">
                            <CustomImageInput
                                name="secondarySingleImage"
                                label="Secondary Single Image"
                                data={data}
                                editable={true}
                                onFilesChange={handleChange}
                                col={3}
                            />
                        </div>
                    )}
                </div>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <h5 className="m-0 col-11">Benefits</h5>
                    <i className="pi pi-plus text-green-600 cursor-pointer text-right col-1 m-0" onClick={addBenefit}></i>
                    <div className="col-12">
                        <CustomInput col={8} key="benefitsTitle" label="Benefits Title" name="benefitsTitle" data={data} onChange={handleChange} />
                    </div>
                    {data?.benefits?.map((benefit, index) => {
                        return (
                            <div key={"benefits " + index} className="col-12">
                                <div className="col-8 grid ml-1 flex align-items-center">
                                    <CustomImageInput
                                        name="iconImage"
                                        label="Icon Image"
                                        formArrayName="benefits"
                                        index={index}
                                        data={benefit}
                                        editable={true}
                                        onFilesChange={handleChange}
                                        col={2}
                                    />
                                    <CustomInput
                                        name="title"
                                        formArrayName="benefits"
                                        index={index}
                                        label="Title"
                                        extraClassName="my-auto"
                                        data={benefit}
                                        onChange={handleChange}
                                        col={4}
                                    />
                                    <CustomInput
                                        key={index}
                                        label="Description"
                                        name="description"
                                        formArrayName="benefits"
                                        index={index}
                                        extraClassName="my-auto"
                                        data={benefit}
                                        onChange={handleChange}
                                        col={5}
                                    />
                                    {index > 0 ? (
                                        <i className="pi pi-times text-red-600 cursor-pointer col-1 mt-3" onClick={() => removeBenefit(index)}></i>
                                    ) : null}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </CustomForm>
            <div className="w-full text-right">
                <PrimaryButton extraClassName="w-2" label="Preview Service" loading={loading} onClick={() => onPreview(type)} />
            </div>

            {type !== "ADD" && (
                <>
                    {!data?.service ? (
                        <ServiceTable heading={"Sub Services"} allServices={subServices} loading={loading} history={history} onDelete={onDelete} />
                    ) : null}
                    {type === "EDIT" ? (
                        <div className="w-full text-left mb-3">
                            <PrimaryButton extraClassName="w-2" label="Add Item" loading={loading} onClick={() => addItem("ITEM")} />
                            <PrimaryButton
                                extraClassName="w-2"
                                label="Add Additinal Service"
                                loading={loading}
                                onClick={() => addItem("ADDITIONAL_SERVICE")}
                            />
                        </div>
                    ) : null}
                    <div className="mb-3">
                        <ItemsTable
                            heading={"Service Items"}
                            items={data?.items}
                            onEdit={(item) => editItem("ITEM", item)}
                            onDelete={onDeleteItem}
                            formType={type}
                        />
                    </div>
                    <div className="mb-3">
                        <ItemsTable
                            heading={"Additional Services"}
                            items={data?.additionalServices}
                            onEdit={(item) => editItem("ADDITIONAL_SERVICE", item)}
                            onDelete={onDeleteAdditionalService}
                            formType={type}
                        />
                    </div>
                </>
            )}

            <Dialog
                visible={visible}
                style={{ width: "30vw" }}
                onHide={() => {
                    if (!visible) return;
                    setVisible(false);
                }}
            >
                <div className="w-full">
                    <CustomInput col={12} key="name" label="Name" name="name" data={item} onChange={handleItemChange} />
                    <CustomInputNumber
                        col={12}
                        key="price"
                        maxFractionDigits={2}
                        locale="en-US"
                        label="Price"
                        name="price"
                        data={item}
                        onChange={handleItemChange}
                    />
                </div>

                <div className="flex w-full mb-3 justify-content-end">
                    {type === "EDIT" && <PrimaryButton label={item._id ? "Update Item" : "Add Item"} loading={loading} onClick={createItem} />}
                    <PrimaryButtonOutlined
                        label="Cancel"
                        onClick={() => {
                            setVisible(false);
                            resetItemForm();
                        }}
                    />
                </div>
            </Dialog>
        </>
    );
};

export default ServiceForm;
